export default __webpack_public_path__ + "images/40f696c3e573901a8714f0214488102a-military_small.webp";